import React, { useState, useContext, useRef } from "react";
import { Context } from "../../context";
import { useNavigate } from 'react-router-dom';
import ReCAPTCHA from "react-google-recaptcha";

import AuthService from "../../services/auth.service";

const LoginForm = () => {
  const [emailOrUsername, setEmailOrUsername] = useState("");
  const [password, setPassword] = useState("");

  const { dispatch } = useContext(Context);
  const [message, setMessage] = useState("");

  const navigate = useNavigate();
  const captchaRef = useRef(null);

  const timeout = (ms) => {
    return new Promise(resolve => setTimeout(resolve, ms));
  }

  const handleSubmit = (e) => {
    e.preventDefault();

    // reset captcharef on submit
    const recaptcha_token = captchaRef.current.getValue();
    captchaRef.current.reset();

    AuthService.login({ emailOrUsername, password, recaptcha_token })
      .then(async (res) => {
        const data = res.data.data;
        const data_jsn = JSON.stringify(data)
        localStorage.setItem("loggedInUser", data_jsn);
        dispatch({
          type: "LOGIN",
          payload: {
            user: data,
            token: data.token,
          },
        });
        setMessage(res.message)
        await timeout(500);
        navigate("/");
      })
      .catch((err) => {
        console.error('err: failed login', err);
        if (err && err.response && err.response.data){
          setMessage(err.response.data)
        }
      });

    
  };

  return (
    <form className="mt-8 space-y-6" onSubmit={handleSubmit}>
      <div className="rounded-md shadow-sm -space-y-px">
        <div style={{ margin: "1.5vh" }}>
          <label htmlFor="username" className="sr-only" style={{ marginRight: "1.5vh" }}>
            Username/Email
          </label>
          <input
            className="input-field"
            id="username"
            name="username"
            type="text"
            autoComplete="username"
            required
            placeholder="Username"
            value={emailOrUsername}
            onChange={(e) => setEmailOrUsername(e.target.value)}
          />
        </div>
        <div style={{ margin: "1.5vh" }}>
          <label htmlFor="password" className="sr-only" style={{ marginRight: "1.5vh" }}>
            Password
          </label>
          <input
            className="input-field"
            id="password"
            name="password"
            type="password"
            autoComplete="current-password"
            required
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
        </div>
      </div>
      <div>
        <ReCAPTCHA 
          className="verifier"
          sitekey={process.env.REACT_APP_RECAPTCHA_SITE_KEY}
          ref={captchaRef}
        />
      </div>
      <div>
        <button
          type="submit"
          className="small-custom-button"
        >
          <span className="absolute left-0 inset-y-0 flex items-center pl-3">
            <svg
              className="h-5 w-5 text-indigo-500 group-hover:text-indigo-400"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 20 20"
              fill="currentColor"
              aria-hidden="true"
            >
              <path
                fillRule="evenodd"
                d="M5 9V7a5 5 0 0110 0v2a2 2 0 012 2v5a2 2 0 01-2 2H5a2 2 0 01-2-2v-5a2 2 0 012-2zm8-2v2H7V7a3 3 0 016 0z"
                clipRule="evenodd"
              />
            </svg>
          </span>
          Login
        </button>
      </div>

      <div style={{ margin: "1.5vh" }}>
        {message}
      </div>

    </form>
  );
};

export default LoginForm;